import { ROUTER_PROCESSOR_ADDRESS } from '@emberswap/emberswap-sdk2/dist/constants'
import { zeroAddress } from 'viem'
import { useWalletClient } from 'wagmi'
import { getContract } from 'wagmi/actions'

import { routeProcessor3 } from '../constants/abis/routeProcessor3'

// TODO CELO NOT FOUND?
export const getRouterProcessorContractConfig = (chainId: number | undefined) => ({
  address: chainId ? ROUTER_PROCESSOR_ADDRESS[chainId] : zeroAddress,
  abi: routeProcessor3,
})

/**
 * @param {number | undefined}chainId
 * @return {Contract | null}
 */
export function useRouteProcessorContract(chainId: number | undefined) {
  const { data: walletClient } = useWalletClient()
  return getContract({
    ...getRouterProcessorContractConfig(chainId),
    walletClient: walletClient ? walletClient : undefined,
  })
}

export type SushiSwapRouter = NonNullable<ReturnType<typeof useRouteProcessorContract>>
